import React from 'react'

import styled from '@emotion/styled'
import { mq, black02, green01, text } from '../../_style'
import Heading from '../atoms/heading';
import EnHeading from '../atoms/enHeading';
import { css } from '@emotion/core';

const Container = styled.div`
  ${props => props.inPageMain && `
    ${mq.pc} {
      position: absolute;
      top: ${props.isHistory ? (132 / 560 * 100) : (244 / 560 * 100)}%;
      left: 0;
    }
    ${mq.pcMin} {
      left: 40px;
    }
    ${mq.sp} {
      padding: 60px 20px 0;
    }
  `}
  ${props => props.isCenter && `text-align: center;`}
`
const Sub = styled.div`
  margin-bottom: 35px;
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
`
export default class HeadingSet extends React.Component {
  render() {
    return(
      <Container inPageMain={this.props.inPageMain} isCenter={this.props.isCenter} isHistory={this.props.isHistory}>
        {this.props.en && <EnHeading inHeadingSet isCenter={this.props.isCenter}>{this.props.en}</EnHeading>}
        {this.props.sub && <Sub>{this.props.sub}</Sub>}
        <Heading>{this.props.children}</Heading>
      </Container>
    )
  }
}
